"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const bem_helper_1 = require("../../helpers/bem-helper");
const AvatarConstants_1 = require("./AvatarConstants");
const Icon_1 = __importDefault(require("../Icon/Icon"));
require("./AvatarContent.scss");
const AVATAR_CONTENT_CSS_BASE_CLASS = "monday-style-avatar-content";
const bemHelper = (0, bem_helper_1.BEMClass)(AVATAR_CONTENT_CSS_BASE_CLASS);
const AvatarContent = ({ type = AvatarConstants_1.AvatarType.TEXT, src, icon, text, ariaLabel, role, size = AvatarConstants_1.AvatarSize.LARGE, textClassName = "" }) => {
    const className = (0, classnames_1.default)(bemHelper({ element: type }), bemHelper({ element: type, state: size }));
    switch (type) {
        case AvatarConstants_1.AvatarType.IMG:
            return (0, jsx_runtime_1.jsx)("img", { role: role, alt: ariaLabel, src: src, className: className });
        case AvatarConstants_1.AvatarType.ICON:
            return ((0, jsx_runtime_1.jsx)(Icon_1.default, { icon: icon, "aria-label": ariaLabel, 
                // role={role}
                clickable: false, className: className, ariaHidden: false }));
        case AvatarConstants_1.AvatarType.TEXT:
            return ((0, jsx_runtime_1.jsx)("span", Object.assign({ "aria-label": ariaLabel, role: role, className: (0, classnames_1.default)(className, textClassName) }, { children: text })));
        default:
            return null;
    }
};
exports.AvatarContent = AvatarContent;
Object.assign(exports.AvatarContent, {
    types: AvatarConstants_1.AvatarType,
    sizes: AvatarConstants_1.AvatarSize
});
